<template>
  <div>
    <!-- <b-dropdown class="dropdown-files" :disabled="disabled">
      <template #button-content>
        <i class="icofont-download"></i>
        {{ label }}
      </template>

      <b-dropdown-item v-if="xlsEnabled" href="#" @click.prevent="exportXls">
        <i class="icofont-file-excel"></i>
        {{ xlsLabel }}
      </b-dropdown-item>

      <b-dropdown-item v-if="csvEnabled" href="#" @click.prevent="exportCsv">
        <i class="icofont-file-excel"></i>
        {{ csvLabel }}
      </b-dropdown-item>
    </b-dropdown> -->

    <div>
      <b-button
        class="export-file-button"
        :disabled="disabled"
        @click.prevent="exportXls"
      >
        <i class="icofont-file-excel"></i>
        {{ label }}
      </b-button>
    </div>
  </div>
</template>

<script>
import ExportFileService from '@/services/ExportFileService'

export default {
  name: 'ExportFiles',

  props: {
    filename: {
      type: String,
      default: 'arquivo',
    },
    sheetName: {
      type: String,
      default: 'Planilha',
    },
    columns: {
      type: Array,
      default: () => [],
    },
    rows: {
      type: Array,
      default: () => [],
    },
    xlsEnabled: {
      type: Boolean,
      default: true,
    },
    csvEnabled: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: 'Exportar',
    },
    xlsLabel: {
      type: String,
      default: 'XLS',
    },
    csvLabel: {
      type: String,
      default: 'CSV',
    },
    logEnabled: {
      type: Boolean,
      default: true,
    },
    afterRows: {
      type: Array,
      default: () => [],
    },
  },

  methods: {
    exportXls() {
      this.postLog()

      ExportFileService.exportXls({
        filename: this.filename,
        sheetName: this.sheetName,
        columns: this.columns,
        rows: this.rows,
        afterRows: this.afterRows,
      })
    },

    exportCsv() {
      this.postLog()

      ExportFileService.exportCsv({
        filename: this.filename,
        columns: this.columns,
        rows: this.rows,
        afterRows: this.afterRows,
      })
    },

    postLog() {
      if (!this.logEnabled) {
        return
      }

      const payload = {
        id: this.$store.state.id,
        nome: this.$store.state.username,
        cod_ibge: this.$store.state.cod_ibge,
        page: this.$route.path,
      }

      this.$api.post('/app/logs-download', payload)
    },
  },
}
</script>

<style>
.dropdown-files button.dropdown-toggle {
  color: #fff;
  background-color: #545b62;
  border-color: #4e555b;
}

.dropdown-files ul {
  padding: 10px !important;
  border-radius: initial !important;
  align-items: center;
  justify-content: flex-start;
}

.dropdown-files ul li a {
  padding: 5px 15px;
}

.export-file-button {
  color: #fff;
  background-color: #198754;
  border-color: #198754;
  font-weight: 700;
  border-radius: 8px;
  padding: 8px 14px;
  font-size: 12px;
  text-transform: initial;
}

.export-file-button:hover {
  color: #fff;
  background-color: #157347;
  border-color: #146c43;
}
</style>
